import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 得到设备支持的开关模式以及节能模式
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	supplyType() {
		return request({
	    url: baseUrl + '/device/getSupplyType',
	    method: 'GET'
	  })
	},
	/**
	 * 策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/programme',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 策略添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/device/programme',
			method:'POST',
			data
		})
	},


	/**
	 * 策略编辑
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/device/programme/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 策略删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/device/programme/'+id,
			method:'DELETE'
		})
	}
}